import * as echarts from 'echarts';
import { EleResize } from './a.js'
import chinaMap from "@/assets/get/china.json"
import i18n from "@/i18n";

const sankeyEcharts = (options) => {
    let { chartDom, dataList, mode } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });

    let { level_1, level_2, level_3, level_4 } = dataList
    let totalAMBooking = level_4.booking + level_4.unplanned

    let channel4 = [{
            name: '_',
            itemStyle: {
                color: '#00000000'
            },
            value: 10000,
            depth: 0,
            label:{
                show: false
            },
            emphasis:{
            disabled: true
            }
        },
        {
            name: '__',
            itemStyle: {
                color: '#00000000'
            },
            value: 10000,
            depth: 2,
            label:{
                show: false
            },
            emphasis:{
            disabled: true
            }
        },
        {
            name: '___',
            itemStyle: {
                color: '#00000000'
            },
            value: 10000,
            depth: 3,
            label:{
                show: false
            },
            emphasis:{
                disabled: true
            }
        },{
            name: 'IIoT',
            itemStyle: {
                color: '#5FA6C8'
            },
            value: 10000,
            depth: 0,
            label:{
                formatter: [
                    '{a|IIoT}', '{b|¥0}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|0% vs 0%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    }
                }
            }
        },
        {
            name: 'Auditing',
            itemStyle: {
                color: '#7BB5BA'
            },
            value: 10000,
            depth: 0,
            label:{
                formatter: [
                    '{a|Auditing}', '{b|¥0}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|0% vs 0%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    }
                }
            }
        },
        {
            name: 'Prediction',
            itemStyle: {
                color: '#A170D2'
            },
            value: 10000,
            depth: 0,
            label:{
                formatter: [
                    '{a|Prediction}', '{b|¥0}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|0% vs 0%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    }
                }
            }
        }
    ]
    if (mode == "2") {
        channel4 = []
    }

    var nodes = [
        ...channel4,
        {
            name: 'Package',
            itemStyle: {
                color: '#F1C0BE'
            },
            value: 10000,
            depth: 0,
            label:{
                formatter: [
                    '{a|Package}', '{b|¥' + parseInt(level_1.package.value).toLocaleString() + ' }',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|' + level_1.package.realisation_rate.toFixed(2) + '% vs ' + level_1.package.variance_rate.toFixed(2) + '%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    }
                }
            }
        },
        {
            name: 'Replacement',
            depth: 1,
            value: 10000,
            label: {
                formatter: [
                    '{a|Replacement} {b|¥' + parseInt(level_2.replacement.value).toLocaleString() + ' (' + level_2.replacement.rate.toFixed(2) + '%)}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|' + level_2.replacement.realisation_rate.toFixed(2) + '% vs ' + level_2.replacement.variance_rate.toFixed(2) + '%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    c: {
                        fontSize: 14,
                        color: '#FFFFFF',
                        padding:[10, 0, 0, 0]
                    }
                }
            },
            // itemStyle: {
            //   color: {
            //     type: 'linear',
            //     x: 0,
            //     y: 0,
            //     x2: 0,
            //     y2: 1,
            //     colorStops: [
            //       {
            //         offset: 0,
            //         color: '#E7C083' // 0% 处的颜色
            //       },
            //       {
            //         offset: level_2.replacement.realisation_rate.toFixed(2) / 100,
            //         color: '#E7C083' // 100% 处的颜色
            //       },
            //       {
            //         offset: level_2.replacement.realisation_rate.toFixed(2) / 100,
            //         color: '#C6C1C1' // 100% 处的颜色
            //       },
            //       {
            //         offset: 1,
            //         color: '#C6C1C1' // 100% 处的颜色
            //       }
            //     ],
            //     global: false // 缺省为 false
            //   }
            // }
        }, {
            name: 'Spare Parts',
            depth: 1,
            value: 10000,
            label: {
                formatter: [
                    '{a|Spare Parts} {b|¥' + parseInt(level_2.spare.value).toLocaleString() + ' (' + level_2.spare.rate.toFixed(2) + '%)}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|' + level_2.spare.realisation_rate.toFixed(2) + '% vs ' + level_2.spare.variance_rate.toFixed(2) + '%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    c: {
                        fontSize: 14,
                        color: '#FFFFFF',
                        padding:[10, 0, 0, 0]
                    }
                }
            }
        }, {
            name: 'Service',
            depth: 1,
            value: 10000,
            label: {
                formatter: [
                    '{a|Service} {b|¥' + parseInt(level_2.service.value).toLocaleString() + ' (' + level_2.service.rate.toFixed(2) + '%)}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|' + level_2.service.realisation_rate.toFixed(2) + '% vs ' + level_2.service.variance_rate.toFixed(2) + '%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    c: {
                        fontSize: 14,
                        color: '#FFFFFF',
                        padding:[10, 0, 0, 0]
                    }
                }
            }
        }, {
            name: 'Repair',
            depth: 1,
            value: 10000,
            label: {
                formatter: [
                    '{a|Repair} {b|¥' + parseInt(level_2.repair.value).toLocaleString() + ' (' + level_2.repair.rate.toFixed(2) + '%)}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|' + level_2.repair.realisation_rate.toFixed(2) + '% vs ' + level_2.repair.variance_rate.toFixed(2) + '%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    c: {
                        fontSize: 14,
                        color: '#FFFFFF',
                        padding:[10, 0, 0, 0]
                    }
                }
            }
        }, {
            name: 'Upgrading',
            depth: 1,
            value: 10000,
            label: {
                formatter: [
                    '{a|Upgrading} {b|¥' + parseInt(level_2.upgrading.value).toLocaleString() + ' (' + level_2.upgrading.rate.toFixed(2) + '%)}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|' + level_2.upgrading.realisation_rate.toFixed(2) + '% vs ' + level_2.upgrading.variance_rate.toFixed(2) + '%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    c: {
                        fontSize: 14,
                        color: '#FFFFFF',
                        padding:[10, 0, 0, 0]
                    }
                }
            }
        },  {
            name: 'Care',
            value: 10000,
            depth: 1,
            label: {
                formatter: [
                    '{a|Care} {b|¥0 (0%)}',
                    '{c|Realisation Rate vs Variance Rate}',
                    '{d|N/A% vs N/A%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#FFFFFF',
                    },
                    c: {
                        fontSize: 14,
                        fontWeight: 400,
                        color: '#FFFFFF',
                        padding:[10, 0, 0, 0]
                    }
                }
            }
        }, 
        {
            name: 'Replacement Orders',
            depth: 2,
            label: {
                color: '#ffffff',
                formatter: [
                    '{a|Replacement Orders} {b|¥' + parseInt(level_3.replacement.value).toLocaleString() + ' (' + level_3.replacement.rate.toFixed(2) + '%)}',
                    '',
                    '{c|Unplanned ¥' + parseInt(level_3.replacement.link.Unplanned).toLocaleString() + ' (' + (level_3.replacement.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }, 
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }
                }
            }
        }, 
        {
            name: 'Spare Part Orders',
            depth: 2,
            label: {
                color: '#ffffff',
                formatter: [
                    '{a|Spare Part Orders} {b|¥' + parseInt(level_3.spare.value).toLocaleString() + ' (' + level_3.spare.rate.toFixed(2) + '%)}',
                    '',
                    '{c|Unplanned ¥' + parseInt(level_3.spare.link.Unplanned).toLocaleString() + ' (' + (level_3.spare.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
                ].join('\n'),
                // verticalAlign: 'bottom',
                // offset:[0, -8],
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }, 
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }
                }
            }
        },
        {
            name: 'Service Orders',
            depth: 2,
            label: {
                color: '#ffffff',
                formatter: [
                    '{a|Service} {b|¥' + parseInt(level_3.service.value).toLocaleString() + ' (' + level_3.service.rate.toFixed(2) + ')}',
                    '',
                    '{c|Unplanned ¥' + parseInt(level_3.service.link.Unplanned).toLocaleString() + ' (' + (level_3.service.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }, 
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }
                }
            }
        },
        {
            name: 'Repair Orders',
            depth: 2,
            label: {
                color: '#ffffff',
                formatter: [
                    '{a|Repair Orders} {b|¥' + parseInt(level_3.repair.value).toLocaleString() + ' (' + level_3.repair.rate.toFixed(2) + '%)}',
                    '',
                    '{c|Unplanned ¥' + parseInt(level_3.repair.link.Unplanned).toLocaleString() + ' (' + (level_3.repair.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }, 
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }
                }
            }
        },
        {
            name: 'Upgrading Orders',
            depth: 2,
            label: {
                color: '#ffffff',
                formatter: [
                    '{a|Upgrading Orders} {b|¥' + parseInt(level_3.upgrading.value).toLocaleString() + ' (' + level_3.upgrading.rate.toFixed(2) + '%)}',
                    '',
                    '{c|Unplanned ¥' + parseInt(level_3.upgrading.link.Unplanned).toLocaleString() + ' (' + (level_3.upgrading.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }, 
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }
                }
            }
        },
        {
            name: 'Care Orders',
            depth: 2,
            value: 100,
            label: {
                color: '#ffffff',
                formatter: [
                    '{a|Care Orders} {b|¥0 (0%)}',
                    '',
                    '{c|Unplanned ¥0 (0%)}',
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }, 
                    b: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#ffffff',
                    }
                }
            }
        },
        {
            name: 'AM Booking',
            itemStyle: {
                color: '#F7D000'
            },
            label: {
                color: '#ffffff',
                formatter: [
                    '{a|AM Booking}',
                    '{b|AM Booking Lifecycle}',
                    '',
                    '{a|¥' + parseInt(level_4.booking / 1000).toLocaleString() + 'K}',
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 48,
                        fontWeight: 600,
                        color: '#ffffff',
                    }, b: {
                        fontSize: 24,
                        fontWeight: 600,
                        color: '#ffffff',
                    }
                }
            },
            depth: 3
        },
        {
            name: 'Unplanned',
            itemStyle: {
                color: '#C6C2C2',
            },
            label: {
                color: '#ffffff',
                formatter:[
                    '{a|Unplanned}',
                    '',
                    '{b|¥' + parseInt(level_4.unplanned / 1000).toLocaleString() + 'K}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 20,
                        fontWeight: 400,
                        color: '#B6B7BC',
                        // padding: [0,0,0,0]
                    }, 
                    b: {
                        fontSize: 36,
                        fontWeight: 600,
                        color: '#ffffff',
                        // padding: [5,5,120,5]
                    }
                },
            },
            depth: 3

        },
    ]
    var links = []

    // levee 1 to 2
    for (let key in level_1.package.link) {
        links.push({
            source: level_1.package.name,
            target: level_2[key].name,
            value: parseInt(level_2[key].rate.toFixed(2) * 100)
        })
    }

    let predictionBiasOfAMBooking = 0
    // level 2 to 3
    for (let key in level_2) {
        let link = level_2[key].link
        for(let i in link){
            if ("Prediction Bias of AM Booking" === i) {
              predictionBiasOfAMBooking += link[i]

              links.push({
                source: level_2[key].name,
                target: i,
                value: parseInt((100 - level_2[key].realisation_rate.toFixed(2)) * 100)
              })
            } else {
              links.push({
                source: level_2[key].name,
                target: i,
                value: parseInt(level_2[key].realisation_rate.toFixed(2) * 100)
              })
            }
        }
    }

    // level 3 to 4
    for (let key in level_3) {
      let link = level_3[key].link
      for(let i in link){
          if (i == "Unplanned"){
              links.push({
                  source: level_3[key].name,
                  target: i,
                  value: parseInt(link[i] / 10000),
                  // edgeLabel: {
                  //     show: true,
                  //     formatter: 'Unplanned ¥' + parseInt(link[i]).toLocaleString() +' ('+(link[i]/level_4.unplanned*100).toFixed(2)+'%)',
                  //     verticalAlign: 'middle',
                  //     fontSize: 20,
                  //     offset: [-18, -88],
                  //     color: '#fff'
                  // },
                  lineStyle: {
                      color: '#C6C1C1'
                  }
              })
          }
          else{
              links.push({
                  source: level_3[key].name,
                  target: i,
                  value: parseInt(link[i] / 10000)
              })
          }
      }
    }

    nodes.push(
        {
            name: 'Prediction Bias of AM Booking',
            itemStyle: { color: '#A64C4C' },
            label: {
                formatter: [
                    '{a|Prediction Bias of AM Booking}',
                    '{b|¥' + parseInt(predictionBiasOfAMBooking / 1000).toLocaleString() + 'K}',
                    '{c|Opportunity Variance Rate: ' + parseInt(predictionBiasOfAMBooking / level_4.booking * 100) + '%}'
                ].join('\n'),
                rich: {
                    a: {
                        fontSize: 20,
                        fontWeight: 400,
                        color: '#B6B7BC',
                        // padding: [0,0,0,0]
                    }, b: {
                        fontSize: 36,
                        fontWeight: 600,
                        color: '#FFFFFF',
                        // padding: [0,0,0,0]

                    }, c: {
                        fontSize: 18,
                        fontWeight: 500,
                        color: '#B6B7BC',
                        // padding: [0,0,65,0]
                    }
                }
            },
            depth: 3
        })

    let option = {
        // tooltip: {
        //     trigger: 'item',
        //     triggerOn: 'mousemove'
        // },
        series: [
            {
                type: 'sankey',
                layout: 'none',
                top: '5%',
                left: '0%',
                // right: '20%',
                height: '80%',
                nodeGap: 62,
                nodeWidth: 40,
                nodeAlign: 'left',
                layoutIterations: 0, // 自动优化列表，尽量减少线的交叉，为0就是按照数据排列
                data: nodes, // 节点
                links: links, // 节点之间的连线
                draggable: false,
                focusNodeAdjacency: 'allEdges', // 鼠标划上时高亮的节点和连线，allEdges表示鼠标划到节点上点亮节点上的连线及连线对应的节点
                // tooltip: {
                //   formatter: function(params) {
                //     if (params.data.source) {
                //       return `${params.data.source}：${params.data.value}`;
                //     } else {
                //       return `${params.name}：${params.value}`;
                //     }
                //   }
                // },
                levels: [{
                    depth: 0,
                    lineStyle: {
                        color: 'source',
                        opacity: 0.25
                    }
                },
                {
                    depth: 1,
                    itemStyle: {
                        color: '#E7C083'
                    },
                    lineStyle: {
                        color: 'source',
                        opacity: 0.25
                    }
                },
                {
                    depth: 2,
                    itemStyle: {
                        color: '#0D99FF'
                    },
                    lineStyle: {
                        color: 'source',
                        opacity: 0.25
                    }
                },
                {
                    depth: 3,
                    label: {
                        fontSize: 12
                    }
                }
                ],
                label: {
                    fontSize: 14,
                    color: '#ffffff'
                },
                itemStyle: {
                    normal: {
                        borderWidth: 0
                    }
                }
            }
        ]
    }


    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    console.log(JSON.stringify(option))
    myChart && option && myChart.setOption(option)
}
const sankeyEcharts1 = (options) => {
  let { chartDom, dataList, mode } = options;
  let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });

  let { level_1, level_2, level_3, level_4 } = dataList
  let totalAMBooking = level_4.booking + level_4.unplanned
  let level3_value = level_2.replacement.realisation_rate.toFixed(2) * 100

  let channel4 = [{
          name: '_',
          itemStyle: {
              color: '#00000000'
          },
          value: 10000,
          depth: 0,
          label:{
              show: false
          },
          emphasis:{
            disabled: true
          }
        },
        {
            name: '__',
            itemStyle: {
                color: '#00000000'
            },
            value: 10000,
            depth: 2,
            label:{
                show: false
            },
            emphasis:{
            disabled: true
            }
        },
        {
            name: '___',
            itemStyle: {
                color: '#00000000'
            },
            value: 10000,
            depth: 3,
            label:{
                show: false
            },
            emphasis:{
                disabled: true
            }
        },{
          name: 'IIoT',
          itemStyle: {
              color: '#5FA6C8'
          },
          value: 10000,
          depth: 0,
          label:{
              formatter: [
                  '{a|IIoT}', '{b|¥0}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|0% vs 0%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  }
              }
          }
      },
      {
          name: 'Auditing',
          itemStyle: {
              color: '#7BB5BA'
          },
          value: 10000,
          depth: 0,
          label:{
              formatter: [
                  '{a|Auditing}', '{b|¥0}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|0% vs 0%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  }
              }
          }
      },
      {
          name: 'Prediction',
          itemStyle: {
              color: '#A170D2'
          },
          value: 10000,
          depth: 0,
          label:{
              formatter: [
                  '{a|Prediction}', '{b|¥0}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|0% vs 0%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  }
              }
          }
      }
  ]
  if (mode == "2") {
      channel4 = []
  }

  var nodes = [
      ...channel4,
      {
          name: 'Package',
          itemStyle: {
              color: '#F1C0BE'
          },
          value: 10000,
          depth: 0,
          label:{
              formatter: [
                  '{a|Package}', '{b|¥' + parseInt(level_1.package.value).toLocaleString() + ' }',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|' + level_1.package.realisation_rate.toFixed(2) + '% vs ' + level_1.package.variance_rate.toFixed(2) + '%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  }
              }
          }
      },
      {
          name: 'Replacement',
          depth: 1,
          value: 10000,
          label: {
              formatter: [
                  '{a|Replacement} {b|¥' + parseInt(level_2.replacement.value).toLocaleString() + ' (' + level_2.replacement.rate.toFixed(2) + '%)}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|' + level_2.replacement.realisation_rate.toFixed(2) + '% vs ' + level_2.replacement.variance_rate.toFixed(2) + '%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  c: {
                      fontSize: 14,
                      color: '#FFFFFF',
                      padding:[10, 0, 0, 0]
                  }
              }
          }
      }, {
          name: 'Spare Parts',
          depth: 1,
          value: 10000,
          label: {
              formatter: [
                  '{a|Spare Parts} {b|¥' + parseInt(level_2.spare.value).toLocaleString() + ' (' + level_2.spare.rate.toFixed(2) + '%)}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|' + level_2.spare.realisation_rate.toFixed(2) + '% vs ' + level_2.spare.variance_rate.toFixed(2) + '%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  c: {
                      fontSize: 14,
                      color: '#FFFFFF',
                      padding:[10, 0, 0, 0]
                  }
              }
          }
      }, {
          name: 'Service',
          depth: 1,
          value: 10000,
          label: {
              formatter: [
                  '{a|Service} {b|¥' + parseInt(level_2.service.value).toLocaleString() + ' (' + level_2.service.rate.toFixed(2) + '%)}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|' + level_2.service.realisation_rate.toFixed(2) + '% vs ' + level_2.service.variance_rate.toFixed(2) + '%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  c: {
                      fontSize: 14,
                      color: '#FFFFFF',
                      padding:[10, 0, 0, 0]
                  }
              }
          }
      }, {
          name: 'Repair',
          depth: 1,
          value: 10000,
          label: {
              formatter: [
                  '{a|Repair} {b|¥' + parseInt(level_2.repair.value).toLocaleString() + ' (' + level_2.repair.rate.toFixed(2) + '%)}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|' + level_2.repair.realisation_rate.toFixed(2) + '% vs ' + level_2.repair.variance_rate.toFixed(2) + '%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  c: {
                      fontSize: 14,
                      color: '#FFFFFF',
                      padding:[10, 0, 0, 0]
                  }
              }
          }
      }, {
          name: 'Upgrading',
          depth: 1,
          value: 10000,
          label: {
              formatter: [
                  '{a|Upgrading} {b|¥' + parseInt(level_2.upgrading.value).toLocaleString() + ' (' + level_2.upgrading.rate.toFixed(2) + '%)}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|' + level_2.upgrading.realisation_rate.toFixed(2) + '% vs ' + level_2.upgrading.variance_rate.toFixed(2) + '%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  c: {
                      fontSize: 14,
                      color: '#FFFFFF',
                      padding:[10, 0, 0, 0]
                  }
              }
          }
      },  {
          name: 'Care',
          value: 10000,
          depth: 1,
          label: {
              formatter: [
                  '{a|Care} {b|¥0 (0%)}',
                  '{c|Realisation Rate vs Variance Rate}',
                  '{d|N/A% vs N/A%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#FFFFFF',
                  },
                  c: {
                      fontSize: 14,
                      fontWeight: 400,
                      color: '#FFFFFF',
                      padding:[10, 0, 0, 0]
                  }
              }
          }
      }, 
      {
          name: 'Replacement Orders',
          depth: 2,
          value: level3_value,
          label: {
              color: '#ffffff',
              formatter: [
                  '{a|Replacement Orders} {b|¥' + parseInt(level_3.replacement.value).toLocaleString() + ' (' + level_3.replacement.rate.toFixed(2) + '%)}',
                  '',
                  '{c|Unplanned ¥' + parseInt(level_3.replacement.link.Unplanned).toLocaleString() + ' (' + (level_3.replacement.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }, 
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }
              }
          }
      }, 
      {
          name: 'Spare Part Orders',
          depth: 2,
          value: level3_value,
          label: {
              color: '#ffffff',
              formatter: [
                  '{a|Spare Part Orders} {b|¥' + parseInt(level_3.spare.value).toLocaleString() + ' (' + level_3.spare.rate.toFixed(2) + '%)}',
                  '',
                  '{c|Unplanned ¥' + parseInt(level_3.spare.link.Unplanned).toLocaleString() + ' (' + (level_3.spare.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
              ].join('\n'),
              // verticalAlign: 'bottom',
              // offset:[0, -8],
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }, 
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }
              }
          }
      },
      {
          name: 'Service Orders',
          depth: 2,
          value: level3_value,
          label: {
              color: '#ffffff',
              formatter: [
                  '{a|Service} {b|¥' + parseInt(level_3.service.value).toLocaleString() + ' (' + level_3.service.rate.toFixed(2) + ')}',
                  '',
                  '{c|Unplanned ¥' + parseInt(level_3.service.link.Unplanned).toLocaleString() + ' (' + (level_3.service.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }, 
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }
              }
          }
      },
      {
          name: 'Repair Orders',
          depth: 2,
          value: level3_value,
          label: {
              color: '#ffffff',
              formatter: [
                  '{a|Repair Orders} {b|¥' + parseInt(level_3.repair.value).toLocaleString() + ' (' + level_3.repair.rate.toFixed(2) + '%)}',
                  '',
                  '{c|Unplanned ¥' + parseInt(level_3.repair.link.Unplanned).toLocaleString() + ' (' + (level_3.repair.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }, 
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }
              }
          }
      },
      {
          name: 'Upgrading Orders',
          depth: 2,
          value: level3_value,
          label: {
              color: '#ffffff',
              formatter: [
                  '{a|Upgrading Orders} {b|¥' + parseInt(level_3.upgrading.value).toLocaleString() + ' (' + level_3.upgrading.rate.toFixed(2) + '%)}',
                  '',
                  '{c|Unplanned ¥' + parseInt(level_3.upgrading.link.Unplanned).toLocaleString() + ' (' + (level_3.upgrading.link.Unplanned/totalAMBooking*100).toFixed(2) + '%)}',
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }, 
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }
              }
          }
      },
      {
          name: 'Care Orders',
          depth: 2,
          value: level3_value,
          label: {
              color: '#ffffff',
              formatter: [
                  '{a|Care Orders} {b|¥0 (0%)}',
                  '',
                  '{c|Unplanned ¥0 (0%)}',
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }, 
                  b: {
                      fontSize: 16,
                      fontWeight: 600,
                      color: '#ffffff',
                  }
              }
          }
      },
      {
          name: 'AM Booking',
          itemStyle: {
              color: '#F7D000'
          },
          label: {
              color: '#ffffff',
              formatter: [
                  '{a|AM Booking}',
                  '{b|AM Booking Lifecycle}',
                  '',
                  '{a|¥' + parseInt(level_4.booking / 1000).toLocaleString() + 'K}',
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 48,
                      fontWeight: 600,
                      color: '#ffffff',
                  }, b: {
                      fontSize: 24,
                      fontWeight: 600,
                      color: '#ffffff',
                  }
              }
          },
          depth: 3
      },
      {
          name: 'Unplanned',
          itemStyle: {
              color: '#C6C2C2',
          },
          label: {
              color: '#ffffff',
              formatter:[
                  '{a|Unplanned}',
                  '',
                  '{b|¥' + parseInt(level_4.unplanned / 1000).toLocaleString() + 'K}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 20,
                      fontWeight: 400,
                      color: '#B6B7BC',
                      // padding: [0,0,0,0]
                  }, 
                  b: {
                      fontSize: 36,
                      fontWeight: 600,
                      color: '#ffffff',
                      // padding: [5,5,120,5]
                  }
              },
          },
          depth: 3

      },
  ]
  var links = []

  // levee 1 to 2
  for (let key in level_1.package.link) {
      links.push({
          source: level_1.package.name,
          target: level_2[key].name,
          value: parseInt(level_2[key].rate.toFixed(2) * 100)
      })
  }

  let predictionBiasOfAMBooking = 0
  // level 2 to 3
  for (let key in level_2) {
      let link = level_2[key].link
      for(let i in link){
          if ("Prediction Bias of AM Booking" === i) {
            predictionBiasOfAMBooking += link[i]

            links.push({
              source: level_2[key].name,
              target: i,
              value: parseInt((100 - level_2[key].realisation_rate.toFixed(2)) * 100)
            })
          } else {
            links.push({
              source: level_2[key].name,
              target: i,
              value: parseInt(level_2[key].realisation_rate.toFixed(2) * 100)
            })
          }
      }
  }

  // level 3 to 4
  for (let key in level_3) {
    let link = level_3[key].link
    let total = 0
    for(let i in link){
      total += link[i]
    }
    for(let i in link){
        if (i == "Unplanned"){
            links.push({
                source: level_3[key].name,
                target: i,
                value: parseInt(link[i] / total * level3_value),
                // edgeLabel: {
                //     show: true,
                //     formatter: 'Unplanned ¥' + parseInt(link[i]).toLocaleString() +' ('+(link[i]/level_4.unplanned*100).toFixed(2)+'%)',
                //     verticalAlign: 'middle',
                //     fontSize: 20,
                //     offset: [-18, -88],
                //     color: '#fff'
                // },
                lineStyle: {
                    color: '#C6C1C1'
                }
            })
        }
        else{
            links.push({
                source: level_3[key].name,
                target: i,
                value: parseInt(link[i] / total * level3_value)
            })
        }
    }
  }

  nodes.push(
      {
          name: 'Prediction Bias of AM Booking',
          itemStyle: { color: '#A64C4C' },
          label: {
              formatter: [
                  '{a|Prediction Bias of AM Booking}',
                  '{b|¥' + parseInt(predictionBiasOfAMBooking / 1000).toLocaleString() + 'K}',
                  '{c|Opportunity Variance Rate: ' + parseInt(predictionBiasOfAMBooking / level_4.booking * 100) + '%}'
              ].join('\n'),
              rich: {
                  a: {
                      fontSize: 20,
                      fontWeight: 400,
                      color: '#B6B7BC',
                      // padding: [0,0,0,0]
                  }, b: {
                      fontSize: 36,
                      fontWeight: 600,
                      color: '#FFFFFF',
                      // padding: [0,0,0,0]

                  }, c: {
                      fontSize: 18,
                      fontWeight: 500,
                      color: '#B6B7BC',
                      // padding: [0,0,65,0]
                  }
              }
          },
          depth: 3
      })

  let option = {
      // tooltip: {
      //     trigger: 'item',
      //     triggerOn: 'mousemove'
      // },
      series: [
          {
              type: 'sankey',
              layout: 'none',
              top: '5%',
              left: '0%',
              // right: '20%',
              height: '80%',
              nodeGap: 62,
              nodeWidth: 40,
              nodeAlign: 'left',
              layoutIterations: 0, // 自动优化列表，尽量减少线的交叉，为0就是按照数据排列
              data: nodes, // 节点
              links: links, // 节点之间的连线
              draggable: false,
              focusNodeAdjacency: 'allEdges', // 鼠标划上时高亮的节点和连线，allEdges表示鼠标划到节点上点亮节点上的连线及连线对应的节点
              // tooltip: {
              //   formatter: function(params) {
              //     if (params.data.source) {
              //       return `${params.data.source}：${params.data.value}`;
              //     } else {
              //       return `${params.name}：${params.value}`;
              //     }
              //   }
              // },
              levels: [{
                  depth: 0,
                  lineStyle: {
                      color: 'source',
                      opacity: 0.25
                  }
              },
              {
                  depth: 1,
                  itemStyle: {
                      color: '#E7C083'
                  },
                  lineStyle: {
                      color: 'source',
                      opacity: 0.25
                  }
              },
              {
                  depth: 2,
                  itemStyle: {
                      color: '#0D99FF'
                  },
                  lineStyle: {
                      color: 'source',
                      opacity: 0.25
                  }
              },
              {
                  depth: 3,
                  label: {
                      fontSize: 12
                  }
              }
              ],
              label: {
                  fontSize: 14,
                  color: '#ffffff'
              },
              itemStyle: {
                  normal: {
                      borderWidth: 0
                  }
              }
          }
      ]
  }


  var listener = () => {

      myChart.resize()
  }
  EleResize.on(chartDom, listener)
  myChart.clear()
  console.log(JSON.stringify(option))
  myChart && option && myChart.setOption(option)
}
const barCharts = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        title: {
            top: 0,
            right: 'center',
            text: 'Opportunity Trend',
            textStyle: {
                fontSize: 32,
                fontWeight: 600,
                color: '#FFFFFF'

            }
        },
        tooltip: {
            trigger: "axis",
            backgroundColor: 'rgba(60, 66, 84, 0.70)',
            borderWidth: 0,
            textStyle: {
                color: '#FFFFFF'
            }
        },
        legend: {
            left: 'center',
            bottom: 0,
            icon: 'circle',
            itemWidth: 8,
            itemHeight: 8,
            data: ['Opportunity from Auditing', 'Opportunity from Maintenance Package', 'Opportunity from IIoT', 'Opportunity Successfully Realised'],
            textStyle: {
                fontSize: 16,
                fontFamily: 'Microsoft YaHei',
                fontWeight: 'normal',
                color: '#FFFFFFA8'
            }
        },
        xAxis: {
            data: [ 
                i18n.global.t("month.jan"),
                i18n.global.t("month.feb"),
                i18n.global.t("month.mar"),
                i18n.global.t("month.apr"),
                i18n.global.t("month.may"),
                i18n.global.t("month.jun"),
                i18n.global.t("month.jul"),
                i18n.global.t("month.aug"),
                i18n.global.t("month.sep"),
                i18n.global.t("month.oct"),
                i18n.global.t("month.nov"),
                i18n.global.t("month.dec")
            ],
            splitLine: {
                show: false
            },
            axisLine: {
                show: false

            },
            axisTick: {
                show: false

            }
        },

        yAxis: [{
            name: 'Bar Chart' + '\n' + '¥ Chinese Yuan',
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(182, 183, 188, 0.20)',
                    type: 'dashed',
                }
            },
        },
        {
            name: 'Line Chart' + '\n' + '¥ Realisation Rate',
            position: 'right',
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(182, 183, 188, 0.20)',
                    type: 'dashed',
                }
            },
        }],
        grid: {
            top: '10%',
            bottom: '10%',
            left: '5%',
            right: '5%'
        },
        color: ['#F1C0BE', '#A170D2', '#99B4C0', '#F7D000', '#F1C0BE', '#A170D2', '#99B4C0', '#F7D000'],
        series: [
            {
                name: "Opportunities from Standard Package",
                yAxisIndex: 0,
                type: "bar",
                barWidth: 20,
                data: [1560, 2400, 3330, 1860, 2820, 3160, 1560, 2400, 3330, 1860, 3820, 2160],
                itemStyle: {
                    borderRadius: [10, 10, 10, 10],
                    color: '#ECBBBA'
                }
            },
            {
                name: "Opportunity from Package",
                yAxisIndex: 0,

                type: "bar",
                barWidth: 20,
                stack:'channel',
                data: [556, 540, 553, 586, 682, 716, 856, 540, 633, 786, 882, 616],
                itemStyle: {
                    borderRadius: [0, 0, 10, 10],
                    color: '#F1BFBE'
                }
            },
            {
                name: "Opportunity from IIoT",
                yAxisIndex: 0,

                type: "bar",
                barWidth: 20,
                stack:'channel',
                data: [135, 234, 143, 151, 228, 131, 245, 354, 453, 538, 138, 131],
                itemStyle: {
                    borderRadius: [0, 0, 0, 0],
                    color: '#5EA5C8'
                }
            },  
            {
                name: "Opportunity from Auditing",
                yAxisIndex: 0,
                type: "bar",
                barWidth: 20,
                stack:'channel',
                data: [106, 140, 233, 86, 282, 116, 156, 140, 133, 186, 182, 116],
                itemStyle: {
                    borderRadius: [0, 0, 0, 0],
                    color: '#7BB5B9'
                }
            },
            {
                name: "Opportunity from Prediction",
                yAxisIndex: 0,
                type: "bar",
                stack:'channel',
                barWidth: 20,
                data: [150, 200, 250, 150, 220, 270, 122, 222, 190, 180, 250, 120],
                itemStyle: {
                    borderRadius: [10, 10, 0, 0],
                    color: '#A16FD1'
                }
            },
            {
                name: "Opportunity Successfully Realised",
                type: "bar",
                barWidth: 20,
                data: [1060, 2000, 2330, 1260, 1820, 2160, 1060, 2000, 3030, 1460, 3020, 1160],
                yAxisIndex: 0,
                itemStyle: {
                    borderRadius: [10, 10, 10, 10],
                    color: '#EFC900'
                }
            },
            {
              name: 'Realisation Rate',
              type: 'line',
              yAxisIndex: 1,
              smooth: true,
              tooltip: {
                valueFormatter: function (value) {
                  return value + '%';
                }
              },
              itemStyle:{
                color: '#F1C0BE'
              },
              data: [82.0, 62.2, 73.3, 84.5, 76.3, 60.2, 90.3, 53.4, 63.0, 66.5, 72.0, 86.2]
            },
            {
              name: 'Realisation Rate',
              type: 'line',
              yAxisIndex: 1,
              smooth: true,
              tooltip: {
                valueFormatter: function (value) {
                  return value + '%';
                }
              },
              itemStyle:{
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#A170D2' // 0% 处的颜色
                      },
                      {
                        offset: 0.303,
                        color: '#7BB5BA' // 100% 处的颜色
                      },
                      {
                        offset: 0.643,
                        color: '#5FA6C8' // 100% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#F1C0BE' // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
              },
              data: [62.0, 72.2, 83.3, 64.5, 86.3, 90.2, 50.3, 63.4, 73.0, 96.5, 82.0, 96.2]
            }
        ]
    }

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    console.log(JSON.stringify(option))
    myChart && option && myChart.setOption(option)
}
const crosswiseBarCharts = (options) => {
    let { chartDom, dataList } = options;
    let myChart = chartDom && echarts.init(chartDom);
    let realisation_data = []
    for (let i = 0; i < dataList.realisation_data.length; i++) {
        realisation_data.push(0 - dataList.realisation_data[i]);
    }

    let i_realisation_label = []
    let i_variance_label = []
    let i_realisation_label_max_length = 0, i_variance_label_max_length = 0
    for (let i = 0; i < dataList.realisation_label.length; i++) {
        let _label = i18n.global.t("province." + dataList.realisation_label[i])
        i_realisation_label.push(_label)
        if (i_realisation_label_max_length < _label.length){
            i_realisation_label_max_length = _label.length
        }
    }
    for (let i = 0; i < dataList.variance_label.length; i++) {
        let _label = i18n.global.t("province." + dataList.variance_label[i])
        i_variance_label.push(_label)
        if (i_variance_label_max_length < _label.length){
            i_variance_label_max_length = _label.length
        }
    }

    let lang = localStorage.getItem("language");
    let factor = 3
    if (lang === 'en'){
        factor = 1
    }

    if (i_realisation_label_max_length > i_variance_label_max_length) {
        i_variance_label[0] = String(i_variance_label[0]).padEnd((i_realisation_label_max_length - i_variance_label[0].length) * factor + i_variance_label[0].length, ' ')
    } else if (i_realisation_label_max_length < i_variance_label_max_length) {
        i_realisation_label[0] = String(i_realisation_label[0]).padStart((i_variance_label_max_length - i_realisation_label[0].length) * factor + i_realisation_label[0].length, ' ')
    }

    let option = {
        legend: {
          data: ['Realisation Rate', 'Variance Rate'],
          icon: 'circle',
        //   itemWidth: 8,
          itemHeight: 8,
          textStyle: {
              fontSize: 16,
              fontWeight: '700',
              color: '#FFFFFF'
          },
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'value',
            // 设置x轴线的属性
            axisLine: {
              lineStyle: {
                color: '#4B4B4B'
              }
            },
            axisLabel: {
                color:'#ffffff',
                formatter (value) {
                    return Math.abs(value) + "%" // 负数取绝对值变正数（x轴本来数据是正负才能分开两边展示的，所以我们只是把负数处理为正数在视觉上显示）
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#4B4B4B',
                    type: 'dotted',
                    opacity: 0.6,
                }
            },
            min:-100,
            max:100,
            splitNumber:10
          }
        ],
        yAxis: [
          {
            type: 'category',
            axisTick: {show: false},
            // 设置y轴线的属性
            axisLabel: {
                color:'#ffffff',
                fontSize: 14,
            },
            axisLine: {
              lineStyle: {
                color: '#999999'
              }
            },
            data: i_realisation_label.reverse() // y轴下到上
          },
          {
            type: 'category',
            axisTick: { show: false },
            position: 'right',
            // 设置y轴线的属性
            axisLabel: {
              color:'#ffffff',
              fontSize: 14,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#999999'
              }
            },
            data: i_variance_label.reverse() // y轴下到上
          }
        ],
        color: ['#11CABE', '#A64C4C'],
        series: [
          {
            name: 'Realisation Rate',
            type: 'bar',
            stack: '总量', // 数据堆叠，同个类目轴上系列配置相同的stack值可以堆叠放置。
              barMaxWidth: '22',
              yAxisIndex: 1,
              itemStyle: {
                borderRadius: 20,
            },
            label: {
              normal: {
                show: true,
                color: '#fff',
                align: 'right',
                fontWeight: 'bold',
                formatter(params) {
                    return parseInt(Math.abs(params.value)) + '%';
                }
              }
            },
            data: realisation_data.reverse()
          },
          {
            name: 'Variance Rate',
            type: 'bar',
            stack: '总量',
                barMaxWidth: '22',
                yAxisIndex: 0,
                itemStyle: {
                    borderRadius: 20,
                },
            // barGap: '-100%',
            // barCategoryGap: '10',
            label: {
              normal: {
                show: true,
                color: '#fff',
                align: 'left',
                fontWeight: 'bold',
                formatter(params) {
                    return parseInt(Math.abs(params.value)) + '%';
                }
              }
            },
            data: dataList.variance_data.reverse()
          }
        ]
      };
    var listener = () => {
        myChart.resize()
    }
    console.log(JSON.stringify(option))
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const chinaCharts = (options) => {
    // var vbgPatternImg = document.createElement("img");
    // vbgPatternImg.style.height = vbgPatternImg.height = vbgPatternImg.width = vbgPatternImg.style.width = "100%";
    // vbgPatternImg.src =require('./卫星地图蒙版.png');
    let { chartDom, dataList, name } = options;
    let myChart = chartDom && echarts.init(chartDom, null, { renderer: 'svg' });
    //各省份的地图json文件
    var provinces = {
        '上海': require('../assets/get/area/上海.json'),
        '河北': require('../assets/get/area/河北.json'),
        '山西': require('../assets/get/area/山西.json'),
        '内蒙古': require('../assets/get/area/内蒙古.json'),
        '辽宁': require('../assets/get/area/辽宁.json'),
        '吉林': require('../assets/get/area/吉林.json'),
        '黑龙江': require('../assets/get/area/黑龙江.json'),
        '江苏': require('../assets/get/area/江苏.json'),
        '浙江': require('../assets/get/area/浙江.json'),
        '安徽': require('../assets/get/area/安徽.json'),
        '福建': require('../assets/get/area/福建.json'),
        '江西': require('../assets/get/area/江西.json'),
        '山东': require('../assets/get/area/山东.json'),
        '河南': require('../assets/get/area/河南.json'),
        '湖北': require('../assets/get/area/湖北.json'),
        '湖南': require('../assets/get/area/湖南.json'),
        '广东': require('../assets/get/area/广东.json'),
        '广西': require('../assets/get/area/广西.json'),
        '海南': require('../assets/get/area/海南.json'),
        '四川': require('../assets/get/area/四川.json'),
        '贵州': require('../assets/get/area/贵州.json'),
        '云南': require('../assets/get/area/云南.json'),
        '西藏': require('../assets/get/area/西藏.json'),
        '陕西': require('../assets/get/area/陕西.json'),
        '甘肃': require('../assets/get/area/甘肃.json'),
        '青海': require('../assets/get/area/青海.json'),
        '宁夏': require('../assets/get/area/宁夏.json'),
        '新疆': require('../assets/get/area/新疆.json'),
        '北京': require('../assets/get/area/北京.json'),
        '天津': require('../assets/get/area/天津.json'),
        '重庆': require('../assets/get/area/重庆.json'),
        '香港': require('../assets/get/area/香港.json'),
        '澳门': require('../assets/get/area/澳门.json'),
    };
    var allData = [

        { name: '北京', value: 10, address: [116.468084,41.482036] },

        { name: '上海', value: 30, address: [121.568735,32.637] },

        { name: '天津', value: 10, address: [117.392549,40.52289] },

        { name: '重庆', value: 50, address: [107.752365,31.056766] },

        { name: '河北', value: 100, address: [115.332051,39.083101] },

        { name: '山西', value: 40, address: [112.314895,38.440437] },

        { name: '辽宁', value: 1, address: [123.058916,42.433133] },

        { name: '吉林', value: 1, address: [126.223251,44.663732] },

        { name: '黑龙江', value: 1, address: [128.430927,47.83353] },

        { name: '浙江', value: 1, address: [120.262527,30.044256] },

        { name: '福建', value: 1, address: [118.12844,26.960557] },

        { name: '山东', value: 1, address: [117.907673,37.138296] },

        { name: '河南', value: 1, address: [113.713089,34.714199] },

        { name: '湖北', value: 1, address: [112.094127,32.029078] },

        { name: '湖南', value: 1, address: [111.726181,28.611706] },

        { name: '广东', value: 1, address: [113.487722,24.583851] },

        { name: '海南', value: 1, address: [109.753071, 20.529443] },

        { name: '四川', value: 1, address: [102.969068,31.648066] },

        { name: '贵州', value: 1, address: [107.011874,27.797423] },

        { name: '云南', value: 1, address: [101.419096,25.4626] },

        { name: '江西', value: 1, address: [115.847176,28.677243] },

        { name: '陕西', value: 1, address: [108.709024,34.959848] },

        { name: '青海', value: 1, address: [95.830917,36.599194] },

        { name: '甘肃', value: 1, address: [104.661619,35.935283] },

        { name: '广西', value: 1, address: [108.925193,24.86611] },

        { name: '新疆', value: 1, address: [86.043555,42.044285] },

        { name: '内蒙古', value: 1, address: [115.111284,44.717132] },

        { name: '西藏', value: 1, address: [88.104052,32.408557] },

        { name: '宁夏', value: 1, address: [106.059814,38.205346] },

        { name: '台湾', value: 1, address: [121.072008,24.609284] },

        { name: '香港', value: 1, address: [114.191419,23.352988] },

        { name: '澳门', value: 1, address: [113.606155,23.15068] },

        { name: '安徽', value: 1, address: [117.115439,33.197103] },

        { name: '江苏', value: 1, address: [119.911828,33.94488] }

    ];

    var mapList = []

    var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            // var geoCoord = provinces[data[i].name] && provinces[data[i].name]['features'] && provinces[data[i].name]['features'][0]['properties']['center'];
            var geoCoord = data[i].address
            if (geoCoord) {
                res.push({
                    name: data[i].name,
                    value: geoCoord.concat(data[i].value),
                    itemStyle: {
                        normal: {
                            color: '#CCEDFF',
                        },
                    },
                    emphasis: {
                        itemStyle: {
                            color: '#CBEDFF70',
                            borderColor: '#FFFFFF',
                            borderWidth: 2,
                            borderType: 'solid',
                            borderDashOffset: 10,
                            borderCap: 'butt',
                            borderJoin: 'bevel',
                            borderMiterLimit: 10,
                            shadowBlur: 10,
                            shadowColor: '#FFFFFF7E',
                        }
                    },
                });
            }
        }
        return res;
    };

    if (name == 'china') {
        loadMap(chinaMap, 'china')
    } else {
        loadMap(provinces[name], name)
    }//初始化全国地图

    /**
     获取对应的json地图数据，然后向echarts注册该区域的地图，最后加载地图信息
     @params {String} mapCode:json数据的地址
     @params {String} name: 地图名称
     */
    function loadMap(mapCode, name) {
        if (name == 'china') {
            allData.map(item => {
                for (let i in dataList) {
                    if (name == 'china') {
                        if (i.includes(item.name)) {
                            item.value = parseInt(dataList[i] || 0)
                            mapList.push(item)
                        }
                    } else {
                        if (i.includes(name)) {
                            item.value = parseInt(dataList[i] || 0)
                            mapList.push(item)
                        }
                    }
                }

            })
            mapList = convertData(mapList)
        } else {
            //             features
            // properties
            mapCode && mapCode.features.map(item => {
                for (let i in dataList) {
                    if (i.includes(item.properties.name)) {
                        var obj = {
                            name: item.properties.name,
                            address: item.properties.center,
                            value: parseInt(dataList[i] || 0)
                        }
                        mapList.push(obj)
                    }
                }

            })
            mapList = convertData(mapList)

        }
        echarts.registerMap(name, mapCode);
        var option = {
            title: {
                top: 0,
                left: '20%',
                text: 'Opportunity Variance',
                textStyle: {
                    fontSize: 32,
                    fontWeight: 600,
                    color: '#FFFFFF'
    
                }
            },
            tooltip: {
                show: true,
                padding: 0,
                triggerOn: 'mousemove',
                enterable: name == 'china' ? false : true,
                alwaysShowContent: false,
                position: function (point) {
                    // 固定在顶部
                    return [point[0] - 60, point[1] - 100];
                },
                backgroundColor: '#FFFFFF00',
                borderColor: '#FFFFFF00',
                renderMode: 'html',
                transitionDuration: 0,
                formatter: function (params) {
                    var mapData = ''
                    for (let i in dataList) {
                        if (i.includes(params.name)) {
                            mapData = parseInt(dataList[i] || 0)
                        }
                    }
                    var name = i18n.global.t("province." + params.name) || params.name

                    if (params.data && mapData) return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                    <div class='position-absolute' style="height:100px;width:300px;top:0px;left:0px;">
                    
                    <img style='width:100%;height:100%' src=${require('./dasd.png')} />
                    </div>
                    <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:15px;left:20px;color:#FFFFFF'>
                        <div class='ms-3 mt-1 fs-16 mb-1'>${name}</div>
                       <div style='width:230px' class='ms-3 mt-2 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background: #CCEDFF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       Variance Rate</div>
                       <div> ${mapData}%</div>
                       </div>
                    </div>
                    </div>`
                    else return `<div style='width:0px;height:0px;background: :#FFFFFF00;border:none' class='position-relative'>
                    <div class='position-absolute' style="height:100px;width:300px;top:0px;left:0px;">
                    
                    <img style='width:100%;height:100%' src=${require('./dasd.png')} />
                    </div>
                    <div class='position-absolute'  id='areaName' class='d-flex flex-wrap align-content-between justify-content-between' style='width:100%;top:15px;left:20px;color:#FFFFFF'>
                        <div class='ms-3 mt-1 fs-16 mb-1'>${name}</div>
                       <div style='width:230px' class='ms-3 mt-2 d-flex justify-content-between'>
                       <div  class='d-flex align-items-center fs-15'><div style='width:9px;height:9px;margin-right:10px;border-radius: 9px;background: #CCEDFF;box-shadow: 0px 10px 5px 0px rgba(0, 0, 0, 0.25);'></div>
                       Variance Rate</div>
                       <div> NA</div>
                       </div>
                    </div>
                    </div>`
                },
            },
            visualMap: {
                min: 0,
                max: 100,
                left: 210,
                bottom: 70,
                calculable: false,
                text: ['100%', '0%'],
                inRange: {
                    color: ['#737B79',"#91D5C5", "#86C4B5", "#DFD28D", "#E1D699", "#D26363"]
                },
                textStyle: {
                    color: '#ffffff',
                    fontSize: 13
                }
            },
            geo: [
                {
                    //第三层投影
                    map: name,
                    top: '8.5%',
                    zlevel: 1,
                    zoom: 1.03, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    show: true,
                    regions: [
                        {
                          name: "南海诸岛",
                          itemStyle: {
                            // 隐藏地图
                            normal: {
                              opacity: 0, // 为 0 时不绘制该图形
                            }
                          },
                          label: {
                            show: false // 隐藏文字
                          },
                          emphasis: {
                            disabled:true
                          },
                          tooltip:false
                        },
                        {
                            name: "台湾",
                            itemStyle: {
                              // 隐藏地图
                              normal: {
                                opacity: 0, // 为 0 时不绘制该图形
                              }
                            },
                            label: {
                              show: false // 隐藏文字
                            },
                            emphasis: {
                              disabled:true
                            },
                            tooltip:false
                          }
                    ],
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            disabled:true,
                            show: false,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            show: false,
                            borderJoin: "round",
                            borderColor: "#0A70B7",
                            borderWidth: 1,
                            areaColor: "#094875",
                        },
                        emphasis: {
                            disabled:true,
                            show: false,
                            areaColor: '#2AB8FF00',
                            borderWidth: 0,
                            borderColor: '#6DCEFF',
                        },
                    },
                },
                {
                    //第二层投影
                    map: name,
                    top: '7.5%',
                    zlevel: 2,
                    zoom: 1.03, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    show: true,
                    regions: [
                        {
                          name: "南海诸岛",
                          itemStyle: {
                            // 隐藏地图
                            normal: {
                              opacity: 0, // 为 0 时不绘制该图形
                            }
                          },
                          label: {
                            show: false // 隐藏文字
                          },
                          emphasis: {
                            disabled:true
                          },
                          tooltip:false
                        },
                        {
                            name: "台湾",
                            itemStyle: {
                              // 隐藏地图
                              normal: {
                                opacity: 0, // 为 0 时不绘制该图形
                              }
                            },
                            label: {
                              show: false // 隐藏文字
                            },
                            emphasis: {
                              disabled:true
                            },
                            tooltip:false
                          }
                    ],
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            disabled:true,
                            show: false,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            show: false,
                            borderJoin: "round",
                            borderColor: "#0A70B7",
                            borderWidth: 1,
                            areaColor: "#094875",
                        },
                        emphasis: {
                            disabled:true,
                            show: false,
                            areaColor: '#2AB8FF00',
                            borderWidth: 0,
                            borderColor: '#6DCEFF',
                        },
                    },
                },
                {
                    //第一层投影
                    map: name,
                    top: '6.5%',
                    zlevel: 3,
                    zoom: 1.03, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    show: true,
                    itemStyle: {
                        normal: {
                            show: true,
                            borderJoin: "round",
                            borderColor: "#9FD7FF",
                            areaColor: '#22366CCC',
                            // borderWidth: 1,
                        },
                        emphasis: {
                            disabled:true,
                            show: false
                        },
                    },
                    regions: [
                        {
                          name: "南海诸岛",
                          itemStyle: {
                            // 隐藏地图
                            normal: {
                              opacity: 0, // 为 0 时不绘制该图形
                            }
                          },
                          label: {
                            show: false // 隐藏文字
                          },
                          emphasis: {
                            disabled:true
                          },
                          tooltip:false
                        },
                        {
                            name: "台湾",
                            itemStyle: {
                              // 隐藏地图
                              normal: {
                                opacity: 0, // 为 0 时不绘制该图形
                              }
                            },
                            label: {
                              show: false // 隐藏文字
                            },
                            emphasis: {
                              disabled:true
                            },
                            tooltip:false
                          }
                    ],
                },
                {
                    // 边框
                    map: name,
                    top: '5.5%',
                    zlevel: 4,
                    zoom: 1.03, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    show: true,
                    regions: [
                        {
                          name: "南海诸岛",
                          itemStyle: {
                            // 隐藏地图
                            normal: {
                              opacity: 0, // 为 0 时不绘制该图形
                            }
                          },
                          label: {
                            show: false // 隐藏文字
                          },
                          emphasis: {
                            disabled:true
                          },
                          tooltip:false
                        }
                    ],
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            disabled:true,
                            show: false,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            show: false,
                            borderJoin: "round",
                            borderColor: "#9FD7FF",
                            areaColor: '#22366CCC',
                            borderWidth: name=='china'?10:10,
                        },
                        emphasis: {
                            disabled:true,
                            show: false
                        },
                    },
                },
                {
                    // 主图
                    map: name,
                    top: '5.5%',
                    zlevel: 5,
                    zoom: 1.03, //当前视角的缩放比例
                    roam: false, //是否开启平游或缩放
                    show: true,
                    regions: [
                        {
                          name: "南海诸岛",
                          itemStyle: {
                            // 隐藏地图
                            normal: {
                              opacity: 1, // 为 0 时不绘制该图形
                            }
                          },
                          label: {
                            show: false,
                            textStyle: {
                                color: '#fff'
                            }
                          },
                          emphasis: {
                              disabled:true,
                              label:{
                                show: false
                              }
                          }
                        }
                    ],
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            show: false,
                            borderJoin: "round",
                            borderColor: "#0A70B7",
                            borderWidth: 1,
                            areaColor: "#094875",
                        },
                        emphasis: {
                            show: false,
                            areaColor: '#094875',
                            borderWidth: 0,
                            borderColor: '#6DCEFF',
                        },
                    },
                },
            ],

            series: [
                {
                    name: 'MAP',
                    type: 'map',
                    zoom: 1.03, //当前视角的缩放比例
                    geoIndex: 4,
                    zlevel: 4,
                    top: '5.5%',
                    mapType: name,
                    hoverAnimation: false,
                    selectedMode: 'false',//是否允许选中多个区域
                    label: {
                        normal: {
                            show: false,
                        },
                        emphasis: {
                            show: false,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    //地图区域的多边形 图形样式
                    itemStyle: {
                        normal: {
                            borderColor: '#2ab8ff',
                            borderWidth: 2,
                            areaColor: '#22366CCC',
                        },
                        emphasis: {
                            areaColor: '#22366C54',
                            borderWidth: 1,
                            borderColor: '#6DCEFF',
                        },
                    },
                    regions: [
                        {
                          name: "南海诸岛",
                          itemStyle: {
                            // 隐藏地图
                            normal: {
                              opacity: 0, // 为 0 时不绘制该图形
                            }
                          },
                          label: {
                            show: false // 隐藏文字
                          },
                          emphasis: {
                            disabled:true
                          },
                          tooltip:false
                        },
                        {
                            name: "台湾",
                            itemStyle: {
                              // 隐藏地图
                              normal: {
                                opacity: 0, // 为 0 时不绘制该图形
                              }
                            },
                            label: {
                              show: false // 隐藏文字
                            },
                            emphasis: {
                              disabled:true
                            },
                            tooltip:false
                          }
                    ],
                    data: allData,
                },
                {
                    name: '点',
                    type: 'scatter',
                    coordinateSystem: 'geo',
                    symbolSize: 20,

                    label: {
                        normal: {
                            show: true,
                            offset: [0, -20],
                            formatter: function (value) {
                                return value.value[2] + '%';
                            },
                            textStyle: {
                                color: '#fff',
                                fontSize: 13,
                                fontWeight: 600
                            },
                        },
                    },
                    zlevel: 6,
                    data: mapList,
                    symbol: 'circle',
                    colorBy: 'data',
                },
            ]
        };
        myChart && option && myChart.setOption(option);
        // curMap = {
        //     mapCode: mapCode,
        //     mapName: name
        // };
    }
    var listener = () => {

        myChart.resize()
    }
    EleResize.on(chartDom, listener)
}
const pieCharts1 = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        title: {
          textAlign: 'center',
          left: '50%',
          text: 'Realised vs Variant',
          textStyle: {
            color: '#fff',
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: 'Realised vs Variant',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '30%'],
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 0, name: 'IIOT', itemStyle: { color: "#5FA6C8" } },
              { value: 0, name: 'Auditing', itemStyle: { color: "#7BB5BA" } },
              { value: 0, name: 'Prediction', itemStyle: { color: "#A170D2" } },
              { value: 70000, name: 'Package', itemStyle: { color: "#F1C0BE" } }
            ]
          },
          {
            name: 'Realised vs Variant',
            type: 'pie',
            radius: ['35%', '60%'],
            labelLine: {
              length: 50
            },
            label: {
              formatter: '{a|{b}}\n{hr|}\n  {b|¥{c}}  {per|({d}%)}  ',
              rich: {
                a: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                },
                hr: {
                  borderColor: '#FFF',
                  width: '105%',
                  borderWidth: 1,
                  height: 0.1
                },
                b: {
                  color: '#FFF',
                  fontSize: 16,
                  fontWeight: 'bold',
                  lineHeight: 22,
                  align: 'center'
                },
                per: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                }
              }
            },
            data: [
              { value: 0, name: 'Realised IIoT Opp.', itemStyle: { color: "#F7D000" }},
              { value: 0, name: 'Variant IIoT Opp.', itemStyle: { color: "#A64C4C" }},
              { value: 0, name: 'Realised Auditing Opp.', itemStyle: { color: "#F7D000" } },
              { value: 0, name: 'Variant Auditing Opp.', itemStyle: { color: "#A64C4C" }},
              { value: 0, name: 'Realised Prediction Opp.', itemStyle: { color: "#F7D000" } },
              { value: 0, name: 'Variant Prediction Opp.', itemStyle: { color: "#A64C4C" }},
              { value: 21000, name: 'Realised Package Opp.', itemStyle: { color: "#F7D000" } },
              { value: 49000, name: 'Variant Package Opp.', itemStyle: { color: "#A64C4C" }}
            ]
          }
        ]
      };

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const pieCharts2 = (options) => {
    let { chartDom,name1,
        name2,
        name3,
        name4,
        name5,
        name6 } = options;
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        title: {
          textAlign: 'center',
          left: '50%',
          text: 'Variance Reasons',
          textStyle: {
            color: '#fff',
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)'
        },
        legend: {
          show: false
        },
        color:['#AC6060', '#995353', '#874949', '#733E3E', '#703434', '#AF7A7A'],
        series: [
          {
            name: 'Realised vs Variant',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '60%'],
      
            label: {
              formatter: '{a|{b}}\n{hr|}\n  {per|{d}%} {b|({c})}',
              rich: {
                a: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                },
                hr: {
                  borderColor: '#FFF',
                  width: '105%',
                  borderWidth: 1,
                  height: 0.1
                },
                b: {
                  color: '#FFF',
                  fontSize: 16,
                  fontWeight: 'bold',
                  lineHeight: 22,
                  align: 'center'
                },
                per: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                }
              }
            },
            labelLine: {
              length: 50
            },
            data: [
              { value: 0, name: name1 },
              { value: 0, name: name2 },
              { value: 0, name: name3 },
              { value: 0, name: name4 },
              { value: 0, name: name5 },
              { value: 0, name: name6 }
            ]
          }
        ]
      };

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const pieCharts3 = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        title: {
          textAlign: 'center',
          left: '50%',
          text: '4 Channels vs Package',
          textStyle: {
            color: '#fff',
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: 'Realised vs Variant',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '60%'],
      
            label: {
              formatter: '{a|{b}}\n{hr|}\n  {b|¥{c}}  {per|({d}%)}  ',
              rich: {
                a: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                },
                hr: {
                  borderColor: '#FFF',
                  width: '105%',
                  borderWidth: 1,
                  height: 0.1
                },
                b: {
                  color: '#FFF',
                  fontSize: 16,
                  fontWeight: 'bold',
                  lineHeight: 22,
                  align: 'center'
                },
                per: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                }
              }
            },
            labelLine: {
              length: 50
            },
            data: [
              {
                value: 500,
                name: 'Realised Standard Maintenance Package Opp.',
                itemStyle: {
                  color: '#F1C0BE'
                }
              },
              {
                value: 500,
                name: 'Closed Standard Maintenance Package Opp.',
                itemStyle: {
                  color: "#A64C4C"
                }
              }
            ]
          }
        ]
      };

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
const pieCharts4 = (options) => {
    let { chartDom } = options;
    let myChart = chartDom && echarts.init(chartDom);
    let option = {
        title: {
          textAlign: 'center',
          left: '50%',
          text: '4 Channels vs Package',
          textStyle: {
            color: '#fff',
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}<br/>{c} ({d}%)'
        },
        legend: {
          show: false
        },
        series: [
          {
            name: 'Realised vs Variant',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '60%'],
      
            label: {
              formatter: '{a|{b}}\n{hr|}\n  {b|¥{c}}  {per|({d}%)}  ',
              rich: {
                a: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                },
                hr: {
                  borderColor: '#FFF',
                  width: '105%',
                  borderWidth: 1,
                  height: 0.1
                },
                b: {
                  color: '#FFF',
                  fontSize: 16,
                  fontWeight: 'bold',
                  lineHeight: 22,
                  align: 'center'
                },
                per: {
                  color: '#FFF',
                  lineHeight: 22,
                  align: 'center',
                  fontSize: 16
                }
              }
            },
            labelLine: {
              length: 50
            },
            data: [
              {
                value: 500,
                name: 'Standard Maintenance Package',
                itemStyle: {
                  color: '#E6C083'
                }
              },
              {
                value: 500,
                name: '4 Channels',
                itemStyle: {
                  color: {
                    type: 'radial',
                    x: myChart.getWidth() / 2,
                    y: myChart.getHeight() / 2,
                    r: myChart.getHeight() * 0.6 / 2,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#5FA6C8' // 0% 处的颜色
                      },
                      {
                        offset: 0.393,
                        color: '#7BB5BA' // 100% 处的颜色
                      },
                      {
                        offset: 0.728,
                        color: '#A170D2' // 100% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#F1C0BE' // 100% 处的颜色
                      }
                    ],
                    global: true // 缺省为 false
                  }
                }
              }
            ]
          }
        ]
      };

    var listener = () => {
        myChart.resize()
    }
    EleResize.on(chartDom, listener)
    myChart.clear()
    myChart && option && myChart.setOption(option)
}
export {
    sankeyEcharts,
    sankeyEcharts1,
    barCharts,
    pieCharts1,
    pieCharts2,
    pieCharts3,
    pieCharts4,
    crosswiseBarCharts,
    chinaCharts
}